import { connect } from 'react-redux';
import {
  searchPages,
  getPagesCount,
  getPaginationPagesCount,
  getPaginationPerPage,
  getPaginationPageNumber,
} from 'store/modules/pages';
import Pagination from '../../../website/components/stateful/Pagination';

const mapStateToProps = state => ({
  disablePagination: true,
  currentPageNumber: getPaginationPageNumber(state),
  totalItems: getPagesCount(state),
  totalPages: getPaginationPagesCount(state),
  descriptor: 'Pages',
  itemsPerPage: getPaginationPerPage(state),
});

const mapDispatchToProps = dispatch => ({
  onChangePerPage: ({ perPage }) => dispatch(searchPages({ pagination: { perPage } })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Pagination);
